import React from 'react';
import { Loading } from '@folio/stripes/components';
import { useActiveRoles, hasRole, hasAtLeastOneRole } from '../utils/permissionsUtils';
import { UserRoleRoleEnum } from '../types/api';
import { AccessDenied } from '../components/AccessDenied';
/**
 * Route guard component for role-based access control.
 * Wraps routes to restrict access based on user roles.
 *
 * @example
 * <RouteGuard allowedRoles={[UserRoleRoleEnum.USER_ADMIN]}>
 *   <UsersList />
 * </RouteGuard>
 */
export var RouteGuard = function (_a) {
    var children = _a.children, allowedRoles = _a.allowedRoles, fallbackComponent = _a.fallbackComponent;
    var _b = useActiveRoles(), activeRoles = _b.roles, isLoading = _b.isLoading;
    if (isLoading) {
        return React.createElement(Loading, null);
    }
    // No role restriction = allow all authenticated users
    if (!allowedRoles || allowedRoles.length === 0) {
        return React.createElement(React.Fragment, null, children);
    }
    // The system administrator (AUTHORITY_ADMIN) bypasses all restrictions
    if (hasRole(activeRoles, UserRoleRoleEnum.AUTHORITY_ADMIN)) {
        return React.createElement(React.Fragment, null, children);
    }
    // Check if user has at least one required role
    if (hasAtLeastOneRole(activeRoles, allowedRoles)) {
        return React.createElement(React.Fragment, null, children);
    }
    // Access denied - show fallback or default AccessDenied component
    return React.createElement(React.Fragment, null, fallbackComponent !== null && fallbackComponent !== void 0 ? fallbackComponent : React.createElement(AccessDenied, null));
};
export default RouteGuard;
